module.exports = __webpack_public_path__ + "static/media/Icon_ContactPhone.fe5f8559.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_ContactPhone.svg
// module id = 2314
// module chunks = 0